function cssSelectorSafeId(id) {
  return id.toString().replaceAll(/(~|!|@|\$|%|\^|&|\*|\(|\)|\+|=|,|\.|\/|'|;|:|"|\?|>|<|\[|\]|\\|{|}|\||`|#|\s)/g, "_");
}
export {
  cssSelectorSafeId
};
//# sourceMappingURL=cssSelectorSafeId.js.map
